module.exports = __webpack_public_path__ + "img/img_series_108.89e81421.png";